import React from "react";
import MainBanner from "./sections/MainBanner";
import OurVaults from "./sections/OurVaults";
import WhyChooseVanar from "./sections/WhyChooseVanar";
import ComingSoon from "./sections/ComingSoon";
import CeffuSection from "./sections/CeffuSection";
import "./style.css";

function Homepage() {
  return (
    <>
      <MainBanner />
      <CeffuSection />
      <OurVaults />
      <WhyChooseVanar />
      <ComingSoon />
    </>
  );
}

export default Homepage;
